export default {
  LOADING_GET_CURRENT_USER: 'LOADING_GET_CURRENT_USER',
  SUCCESS_GET_CURRENT_USER: 'SUCCESS_GET_CURRENT_USER',
  ERROR_GET_CURRENT_USER: 'ERROR_GET_CURRENT_USER',

  LOADING_GET_SETTINGS: 'LOADING_GET_SETTINGS',
  SUCCESS_GET_SETTINGS: 'SUCCESS_GET_SETTINGS',
  ERROR_GET_SETTINGS: 'ERROR_GET_SETTINGS',

  LOADING_GET_CUSTOMER_SETTINGS: 'LOADING_GET_CUSTOMER_SETTINGS',
  SUCCESS_GET_CUSTOMER_SETTINGS: 'SUCCESS_GET_CUSTOMER_SETTINGS',
  ERROR_GET_CUSTOMER_SETTINGS: 'ERROR_GET_CUSTOMER_SETTINGS',

  SET_CUSTOMER_SETTINGS: 'SET_CUSTOMER_SETTINGS',

  LOADING_SIGN_IN: 'LOADING_SIGN_IN',
  SUCCESS_SIGN_IN: 'SUCCESS_SIGN_IN',
  ERROR_SIGN_IN: 'ERROR_SIGN_IN',

  LOADING_GET_VERIFICATION_LIMITS: 'LOADING_GET_VERIFICATION_LIMITS',
  SUCCESS_GET_VERIFICATION_LIMITS: 'SUCCESS_GET_VERIFICATION_LIMITS',
  ERROR_GET_VERIFICATION_LIMITS: 'ERROR_GET_VERIFICATION_LIMITS',
  LOADING_GET_CUSTOMER_TIER: 'LOADING_GET_CUSTOMER_TIER',
  SUCCESS_GET_CUSTOMER_TIER: 'SUCCESS_GET_CUSTOMER_TIER',
  ERROR_GET_CUSTOMER_TIER: 'ERROR_GET_CUSTOMER_TIER',

  LOADING_GET_TIERS: 'LOADING_GET_TIERS',
  SUCCESS_GET_TIERS: 'SUCCESS_GET_TIERS',
  ERROR_GET_TIERS: 'ERROR_GET_TIERS',

  VERIFICATION_LEVEL_CHANGED: 'SIGNALR_INCOME/ReceiveMessage/VerificationLevelChanged',
  DOCUMENTS_STATUS_CHANGED: 'SIGNALR_INCOME/ReceiveMessage/CustomerDocumentStatusEvent',

  LOADING_GET_VERIFICATION_LEVEL: 'LOADING_GET_VERIFICATION_LEVELS',
  SUCCESS_GET_VERIFICATION_LEVEL: 'SUCCESS_GET_VERIFICATION_LEVELS',
  ERROR_GET_VERIFICATION_LEVEL: 'ERROR_GET_VERIFICATION_LEVELS',
} as const;
